<template>
  <div class="h-0 my-8 mx-auto w-full border-t border-gray-400"></div>
</template>